/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_TitleInputs */

const en_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile App Development`)
};

const ar_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطوير تطبيقات الهاتف`)
};

const bn_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মোবাইল অ্যাপ ডেভেলপমেন্ট`)
};

const de_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwicklung mobiler Apps`)
};

const es_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo de Aplicaciones Móviles`)
};

const fr_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développement d'applications mobiles`)
};

const pt_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvimento de aplicativos móveis`)
};

const zh_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移动应用程序开发`)
};

const tr_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil Uygulama Geliştirme`)
};

const ru_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработка мобильных приложений`)
};

const pl_svc_mobile_app_development_title = /** @type {(inputs: Svc_Mobile_App_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tworzenie aplikacji mobilnych`)
};

/**
* | output |
* | --- |
* | "Mobile App Development" |
*
* @param {Svc_Mobile_App_Development_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_title = /** @type {((inputs?: Svc_Mobile_App_Development_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_title(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_title(inputs)
	if (locale === "de") return de_svc_mobile_app_development_title(inputs)
	if (locale === "es") return es_svc_mobile_app_development_title(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_title(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_title(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_title(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_title(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_title(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_title(inputs)
	return en_svc_mobile_app_development_title(inputs)
});
export { svc_mobile_app_development_title as "svc_mobile-app-development_title" }